import { Facebook, Linkedin, Twitter } from "lucide-react";

interface SocialShareProps {
  url: string;
  title: string;
  description: string;
  location?: string | null;
}

export function SocialShare({ url, title, description, location }: SocialShareProps) {
  // Add location context to share text if available
  const shareText = location 
    ? `${title} - Expert insights for ${location} businesses from Danis Painting Co.`
    : `${title} - Expert insights from Danis Painting Co.`;

  // Encode URLs for social sharing
  const encodedUrl = encodeURIComponent(url);
  const encodedTitle = encodeURIComponent(shareText);
  const encodedDescription = encodeURIComponent(description);

  // Social sharing URLs
  const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
  const twitterUrl = `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`;
  const linkedinUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`;

  const handleShare = (platform: string, shareUrl: string) => {
    window.open(
      shareUrl,
      `share-${platform}`,
      'width=600,height=400,scrollbars=yes,resizable=yes'
    );
  };

  return (
    <div className="flex items-center gap-4">
      <span className="text-gray-600 font-medium">Share this article:</span>
      <div className="flex gap-2">
        <button
          onClick={() => handleShare('facebook', facebookUrl)}
          className="flex items-center gap-2 px-4 py-2 bg-[#1877F2] text-white rounded-lg hover:bg-[#1565C0] transition-colors"
          aria-label="Share on Facebook"
        >
          <Facebook size={20} />
          <span className="hidden sm:inline">Facebook</span>
        </button>
        <button
          onClick={() => handleShare('linkedin', linkedinUrl)}
          className="flex items-center gap-2 px-4 py-2 bg-[#0A66C2] text-white rounded-lg hover:bg-[#004182] transition-colors"
          aria-label="Share on LinkedIn"
        >
          <Linkedin size={20} />
          <span className="hidden sm:inline">LinkedIn</span>
        </button>
        <button
          onClick={() => handleShare('twitter', twitterUrl)}
          className="flex items-center gap-2 px-4 py-2 bg-[#1DA1F2] text-white rounded-lg hover:bg-[#0C85D0] transition-colors"
          aria-label="Share on Twitter"
        >
          <Twitter size={20} />
          <span className="hidden sm:inline">Twitter</span>
        </button>
      </div>
    </div>
  );
}
